import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { closePopup } from '../../actions/uiActions'
import { registerUser } from '../../actions/userActions'
import x from '../../images/js/x'

class RegisterUser extends React.Component {
    state = {
        username: "",
        custGUID: "",
        newPW: "",
        confirmNewPW: "",
    }

    changeName = (event) => {
        this.setState({ username: event.target.value })
    }


    handleClick = (event) => {
        event.preventDefault()
        this.props.closePopup()
    }

    handleSubmit = (event) => {
        event.preventDefault()
        this.props.registerUser(this.state.username, this.state.newPW, this.state.confirmNewPW, this.state.custGUID)
    }

    changeText = (event, str) => {
        event.preventDefault()
        this.setState({ [str]: event.target.value })
    }


    populateRoles = () => {
        return (
            <select className="selectDropDown" defaultValue="" onChange={this.handleRole} value={this.state.role} style={{ 'left': '225px', 'marginTop': '3px' }} >
                <option value="" disabled hidden>Select User Role</option>
                <option key={1} value="IEAdmin">IEAdmin</option>
                <option key={2} value="Builder">Customer User</option>
                <option key={3} value="Viewer">Reader</option>
            </select>
        )
    }

    render() {
        return (
            <div className="overlayBox" >
                {x("#77828B", "10px", this.handleClick)}
                <div className="centerBox">
                    <h2>Add A New User</h2>
                    <form className="form" onSubmit={this.handleSubmit} style={{ marginLeft: "10px" }}>
                        <input type="text" name="name" onChange={this.changeName} value={this.state.username} placeholder="Email" />
                        <br /><br />
                        <input type="password" name="name" onChange={(event) => this.changeText(event, "newPW")} value={this.state.newPW} placeholder="New Password" />
                        <br /><br />
                        <input type="password" name="name" onChange={(event) => this.changeText(event, "confirmNewPW")} value={this.state.confirmNewPW} placeholder="Confirm New Password" />
                        <br /><br />
                        <input type="text" name="name" onChange={(event) => this.changeText(event, "custGUID")} value={this.state.custGUID} placeholder="Enter Customer Code" />
                        <br /><br />
                        <input className="submitButton" type="submit" value="Submit" />
                    </form>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, registerUser }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterUser)